import BaseScenesPermissions from 'models/Permissions/BaseScenesPermissions'

class EmissionCarPermissions extends BaseScenesPermissions {}

export default EmissionCarPermissions
